import createCache from '@emotion/cache';

const createEmotionCache = () => {
  let insertionPoint;
  if (typeof document !== 'undefined') {
    insertionPoint = document.querySelector('meta[name="emotion-insertion-point"]');
  }

  return createCache({
    key: 'css',
    prepend: true,
    insertionPoint,
  });
};

export default createEmotionCache;
